import { devOrProd } from '../dev_or_prod'
// @ts-ignore
import { track } from '@dcb/track'

/** 引入新版埋点sdk */
track.sensorsConfig({
  projectKey: '3a3e4a8fd1cb30cc9ef2a32269a69c51', //项目ID
  autoTrack: true, //是否启用全埋点，代码埋点也填true
  console: false, //是否开启console
  // 是否是生产环境(默认是false）
  isProductEnv: devOrProd(false, true),
  platformId: '多彩宝',
})

export const sensorsDirective = track.sensorsDirective
export const sensorsFunTrack = track.sensorsFunTrack

// export const sensorsDirective = () => ''
// export const sensorsFunTrack = () => ''
